import React from 'react'

function ProOwnRes() {
    return (
        <div style={{
            padding: '50px',
            fontSize: '15px',
            lineHeight: '1.6',
            textAlign: 'right',
            direction: 'rtl'
        }}>
            <p style={{ marginBottom: '20px' }}>
                يستهدف هذا المنتج ملاك العقار في السعودية.
            </p>

            <p style={{ marginBottom: '20px' }}>
                حيث تعد السعودية إحدى الدول التي تنعم بأعلى مستويات الأمان
                عالميًا؛ إذ حصلت على المركز الثالث في المؤشر الأمني من بين
                دول مجموعة العشرين، كما تستهدف المملكة أن تصبح 3 من
                مدنها ضمن أفضل 100 مدينة للعيش في العالم.
            </p>

            <div style={{ marginBottom: '15px' }}>
                <h3 style={{
                    fontWeight: 'bold',
                    marginBottom: '10px',
                    fontSize: '16px'
                }}>
                    المزايا العامة:
                </h3>
                <ul style={{
                    listStyleType: 'disc',
                    paddingRight: '20px',
                    margin: 0
                }}>
                    <li style={{ marginBottom: '8px' }}>الإقامة في السعودية مع الأسرة، والتي تشمل الوالدين والأزواج والأبناء الذين تقل أعمارهم عن 25 عامًا.</li>
                    <li style={{ marginBottom: '8px' }}>الانتقال من منشأة إلى أخرى بحرية.</li>
                    <li style={{ marginBottom: '8px' }}>الإعفاء من المقابل المالي المقرر على الوافدين والمرافقين.</li>
                    <li style={{ marginBottom: '8px' }}>خروج حامل الإقامة المميزة وأفراد أسرته من السعودية والعودة إليها دون اشتراط تأشيرة.</li>
                    <li style={{ marginBottom: '8px' }}>إصدار تأشيرات زيارة للأقارب.</li>
                    <li style={{ marginBottom: '8px' }}>استخدام المسارات المُخصصة للمواطنين ومواطني دول مجلس التعاون في المنافذ.</li>
                    <li style={{ marginBottom: '8px' }}>العمل في منشآت القطاع الخاص والانتقال بينها للزوج والزوجة والأبناء.</li>
                    <li style={{ marginBottom: '8px' }}>مزاولة الأعمال التجارية وفقًا لنظام الاستثمار.</li>
                    <li>تملُّك العقارات والانتفاع بها.</li>
                </ul>
            </div>
        </div>
    )
}

export default ProOwnRes